import { ButtonBack } from '../../common/Button/ButtonBack';
import { Link, useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import { useContext, useEffect } from 'react';
import { SiteContext } from '../../../context/SiteContext';
import Links from '../../common/Widgets/Links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { scrollToTop } from '../../common/HelperMethods';

const DriveAwayAncillaryPage = (): JSX.Element => {
  const navigate = useNavigate();

  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandDisplayName } = brand;

  useEffect(() => {
    scrollToTop();
  }, []);

  const goBack = (): void => {
    navigate(-1);
  };

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  return (
    <div>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <h2>Eligibility for Driveaway Insurance</h2>
      <p>
        By proceeding, you confirm the following details about you and all
        drivers:
      </p>
      <ol>
        <li>
          All drivers:
          <ol>
            <li>
              are aged 21 to 79 years (age criteria may vary by vehicle
              variant).
            </li>
            <li>
              have a full UK driving licence held for at least 1 year and have
              been permanent UK residents for the last 3 years.
            </li>
            <li>
              have no unspent criminal convictions and have had no more than 2
              fault claims in the last 3 years.
            </li>
            <li>
              have no driving bans in the last 5 years and have no greater than
              9 penalty points on their licence.
            </li>
            <li>
              have not been refused motor insurance, had any policy cancelled or
              voided, or had special terms imposed.
            </li>
            <li>
              agree to provide us with DVLA access to validate their driving
              licence in the event of a claim.
            </li>
          </ol>
        </li>
        <li>
          The vehicle to be insured:
          <ol>
            <li>
              has a minimum value of £2,000 and is not more than 8 years old.
            </li>
            <li>
              has not been modified from the manufacturer’s original
              specification.
            </li>
            <li>
              will not be used for any business purposes, carriage of goods or
              passengers for hire and reward, racing, pacemaking, speed testing,
              competitions, rallies or trails, track days, whether on a road,
              track or an off-road event, commercial travelling, scrap waste or
              use for any purpose in relation to the motor trade.
            </li>
            <li>
              will only be used for Social, Domestic and Pleasure purposes
              including commuting to one permanent place of business.
            </li>
          </ol>
        </li>
        <li>
          Tracker requirements - for cover to be effective a Thatcham category
          S5 tracking device must be fitted and active for:
          <ol>
            <li>pure electric vehicles valued over £60,000</li>
            <li>petrol and diesel vehicles valued over £65,000</li>
          </ol>
        </li>
        <li>
          The acceptance criteria for non-{brandDisplayName} vehicles vary by
          make and model. Several specific brands are excluded.
        </li>
        <li>
          All cover is subject to the terms and conditions provided with the
          policy, the
          <Link
            id='lnkPolicyDocument'
            className='in-text'
            to={PageAbsolutePath.Insurance.PolicyDocuments}>
            Policy Document
          </Link>
          and the
          <Link
            id='lnkTermsOfBusiness'
            className='in-text'
            to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
            Terms of Business
          </Link>
          .
        </li>
      </ol>
      <p>What if the applicant(s) doesn't meet the above criteria?</p>
      <p>
        Please proceed with the online application regardless to ensure they can
        be issued with their Free £250 Excess Voucher, which can be activated in
        your back office. (This is subject to them qualifying)
      </p>
      <div className='flex-row form-nav'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
        <ButtonContinue
          name='btnProceed'
          text='Proceed to application'
          onClick={() => navigate(PageAbsolutePath.Insurance.AboutYou)}
          additionalClassNames='btn-continue'
        />
      </div>
    </div>
  );
};

export default DriveAwayAncillaryPage;
